export interface StyleOptions {
  id?: string;
}

function includeStyles(
  src: string,
  callback: (value?: unknown) => void,
  error: (err: string | Event) => void,
  options?: StyleOptions,
) {
  if (options?.id) {
    const existingLink = document.getElementById(options.id) as HTMLLinkElement | null;

    if (existingLink) {
      callback();
      return;
    }
  }

  const content = document.head || document.querySelector('head');
  const link = document.createElement('link');

  link.rel = 'stylesheet';
  link.href = src;
  if (options?.id) {
    link.id = options.id;
  }

  link.onload = function () {
    if (callback) {
      callback();
    }
  };

  link.onerror = function (e) {
    error(e);
  };

  content.appendChild(link);
}

export const loadDeferredCss = (url: string, options?: StyleOptions) =>
  new Promise((resolve, reject) => {
    try {
      includeStyles(url, resolve, reject, options);
    } catch (e) {
      reject(e);
    }
  });
